import UfoCowAnimation from "../components/pages/UfoCowAnimation.js";

/**
 * AboutPage interactions
 *
 * @package AGDS
 * @category Modules
 * @module AboutPage
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class AboutPage {
    /**
     * @param {Object} [options={}]
     */
    constructor(options = {}) {
        this.ufoCowAnimation = null;
    }

    /**
     * Initializes.
     *
     * @returns {void}
     */
    init() {
        // Initialize UFO beam animation
        this.ufoCowAnimation = UfoCowAnimation.init();
    }
}
